{
  "tasks.generated_by": "Üreten rutin:",
  "tasks.occurrence_of": "{{value1}} tekrarı",
  "tasks.occurrence_skipped": "Tekrar atlandı",
  "tasks.placement_actions": "Yerleşim işlemleri",
  "tasks.routine_badge": "Rutin",
  "tasks.routine_badge_title": "{{value1}} rutini tarafından üretildi",
  "planner.trash_task": "Görevi sil",
  "planner.trash_task_hint": "Çöp kutusuna taşınır",
  "planner.trash_target": "Görevi silme hedefi",
  "planner.task_trashed": "Görev çöp kutusuna taşındı",
  "periods.zoom_group": "Yakınlaştırma",
  "periods.drag_cancelled": "Taşıma iptal edildi",
  "periods.placed_range": "{{value1}} artık {{value2}} aralığında"
}
